// Asset loading. Called from BootScene.preload() — Phaser handles the rest.
// Previously this file generated procedural placeholder textures; with Kenney's
// 1-Bit Pack now bundled at /assets/tiles.png, we just register the spritesheet
// and every entity references frames from it via SPRITE_FRAMES in sprites.ts.

import Phaser from "phaser";
import {
  SPRITESHEET_KEY,
  SPRITESHEET_PATH,
  SPRITESHEET_TILE,
} from "./sprites";

export function loadAssets(scene: Phaser.Scene): void {
  scene.load.spritesheet(SPRITESHEET_KEY, SPRITESHEET_PATH, {
    frameWidth: SPRITESHEET_TILE,
    frameHeight: SPRITESHEET_TILE,
  });
}
